{
  "name": "battleshark",
  "private": true,
  "version": "0.9.9",
  "type": "module",
  "scripts": {
    "dev": "vite",
    "build": "tsc --noEmit && vite build",
    "preview": "vite preview",
    "test": "vitest run",
    "test:watch": "vitest",
    "type-check": "tsc --noEmit",
    "generate-icons": "node scripts/generate-icons.mjs"
  },
  "dependencies": {
    "@fontsource/jetbrains-mono": "^5.2.8",
    "@fontsource/kode-mono": "^5.2.8",
    "@fontsource/rajdhani": "^5.2.7",
    "@supabase/supabase-js": "^2.105.4",
    "phaser": "^3.86.0",
    "resend": "^6.12.3"
  },
  "devDependencies": {
    "@types/node": "^22.10.0",
    "@vercel/node": "^5.8.0",
    "sharp": "^0.34.5",
    "typescript": "^5.6.3",
    "vite": "^8.0.11",
    "vitest": "^4.1.5"
  }
}
